import { createContext, useContext } from 'react'

export const DarkModeContext = createContext(true)

export function useIsDarkMode(): boolean {
  return useContext(DarkModeContext)
}
